interface UrlConfig {
  API_HOST: string
  APP_DOMAIN: string
  IDAAS_PATHNAME?: string
  DOWN_SAMPLE_MINIAPP: string
  DOWN_SAMPLE_WEBSITE: string
  port?: string
  envName?: string
}

const envConfigBuilder: (envName?: NodeJS.ProcessEnv['URL_TYPE']) => UrlConfig = (envName) => {
  /** 这几个变量得逐个逐个拿，一起拿久拿不到... */
  const { API_HOST } = process.env
  const { APP_DOMAIN } = process.env
  const { IDAAS_PATHNAME } = process.env
  return {
    API_HOST: API_HOST || `https://internal-api.${envName}.tableau-shanghai-test.com`,
    APP_DOMAIN: APP_DOMAIN || `https://app.${envName}.tableau-shanghai-test.com`,
    IDAAS_PATHNAME: IDAAS_PATHNAME || `/business/v1/auth/oauth`,
    envName,
    DOWN_SAMPLE_MINIAPP: '/sample/miniApp.zip',
    DOWN_SAMPLE_WEBSITE: '/sample/website.zip',
    port: process.env.NODE_ENV === 'development' ? ':8000' : '',
  }
}

const { URL_TYPE = 'staging' } = process.env

export default envConfigBuilder(URL_TYPE)

export const PROXY_PREFIX = process.env.NODE_ENV === 'development' ? '/api' : ''
